
import React from 'react';

const RootAnonymous = (props) => {

    const {appComponent, ...restProps} = props;
    return React.createElement(appComponent, restProps);
}

export default RootAnonymous;
